import * as Yup from 'yup'

export const certificadoSchema = Yup.object().shape({
  file: Yup.mixed()
    .required('O certificado é obrigatório')
    .test('fileSize', 'O arquivo é muito grande (máx. 5MB)', (value) => {
      return !value || (value && value.size <= 5 * 1024 * 1024)
    })
    .test('fileType', 'Formato inválido (apenas .pfx ou .pem)', (value) => {
      return (
        !value ||
        (value && ['application/x-pkcs12', 'application/x-x509-ca-cert'].includes(value.type))
      )
    }),
})
